import React from "react"
import PropTypes from "prop-types"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material"

/**
 * Confirmation prompt built on MUI's Dialog. The shared ConfirmationAlert is
 * an RSuite modal, which renders underneath an open MUI dialog -- so screens
 * that confirm from inside a dialog use this one instead.
 */
export default function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = "Delete",
    busy = false,
    onConfirm,
    onCancel
}) {
    return (
        <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            {message && (
                <DialogContent>
                    <DialogContentText>{message}</DialogContentText>
                </DialogContent>
            )}
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onCancel} disabled={busy}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                    disabled={busy}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    confirmLabel: PropTypes.string,
    busy: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}
